export const FLAGS = {
  en: "/images/language/united-kingdom.png",
  fr: "/images/language/france.png",
}

export const LANGUAGES = [
  { id: "en", code: "en", name: "English" },
  { id: "fr", code: "fr", name: "Français" },
]
